
















































import mixins from 'vue-typed-mixins'
import I18N, { Language } from '@/components/I18N.ts'
import SearchInput from '@/components/SearchInput.vue'

import axios from 'axios'

interface Data {
  term: string
  randomWorking: boolean
}

export default mixins(I18N).extend({
  components: {
    SearchInput
  },
  data (): Data {
    return {
      term: this.$route.query.s as string,
      randomWorking: false
    }
  },
  watch: {
    // Clear any errors when route changes
    '$route': {
      handler (): void {
        this.$store.dispatch('clearMessages')
      }
    }
  },
  methods: {
    submitSearch (): void {
      if (this.term) {
        this.$router.push({ name: 'lexemes', query: { s: this.term } })
          .catch((_) => { })
      }
    },
    clickRandom (): void {
      this.randomWorking = true
      axios.get(`${process.env.VUE_APP_API_URL}/lexemes/random`)
        .then(response => {
          this.$router.push({
            name: 'lexeme',
            params: {
              'id': response.data._id
            }
          })
        })
        .then(() => {
          this.randomWorking = false
        })
    }
  }
})
